// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC1Iu2JY1hnvqetezmei4cEXdza2EsKlI8",
  authDomain: "infinity-comic.firebaseapp.com",
  databaseURL: "https://infinity-comic-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "infinity-comic",
  storageBucket: "infinity-comic.appspot.com",
  messagingSenderId: "1046775371319",
  appId: "1:1046775371319:web:848bfecba2881b501911b2",
  measurementId: "G-5CJM4KC969"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const database = getDatabase(app);
export const storage = getStorage(app);

export default app;